import { useTheme } from '../../theme/ThemeContext';
const SIZE_PX = {
  sm: '16px',
  md: '24px',
  lg: '36px',
  xl: '48px'
};
const COLOR_TOKENS = ['success', 'danger', 'warning', 'info', 'default', 'secondary', 'muted'];
function isColorToken(value) {
  return COLOR_TOKENS.includes(value);
}
export function useIconStyles(size, color) {
  var _SIZE_PX$resolvedSize;
  const theme = useTheme();
  function resolveColor(token) {
    if (!token) return undefined;
    if (!isColorToken(token)) return token;
    const tokenMap = {
      success: theme.colors.success,
      danger: theme.colors.danger,
      warning: theme.colors.warning,
      info: theme.colors.info,
      default: theme.colors.text,
      secondary: theme.colors.textSecondary,
      muted: theme.colors.textMuted
    };
    return tokenMap[token];
  }
  const resolvedSize = size !== null && size !== void 0 ? size : 'md';
  const style = {
    // Bound values resolve at runtime and may not be valid IconSize tokens.
    fontSize: (_SIZE_PX$resolvedSize = SIZE_PX[resolvedSize]) !== null && _SIZE_PX$resolvedSize !== void 0 ? _SIZE_PX$resolvedSize : SIZE_PX['md']
  };
  const resolvedColor = resolveColor(color);
  if (resolvedColor) {
    style.color = resolvedColor;
  }
  return {
    style
  };
}